import React from "react";
import styles from "./styles.module.scss";
import SearchResultBucket from "../SearchResultBucket";
import { useGetServiceUserList } from "../../Services/Hooks/useGetServiceUserList";
import { getFormattedResultsForDashboardUsers } from "../../Services/Utils";
import { useAmplitudeTracking } from "Services/Hooks/useAmplitudeTracking";
import { toSnakeCase } from "Services/Utils/toSnakeCase";
import { useUserFilterContext } from "../../Pages/Dashboard/UserFilterContext";

interface DashboardUsersProps {
  searchValue: string;
}

const DashboardUsers = ({
  searchValue,
}: DashboardUsersProps) => {
  const { selectedFilter } = useUserFilterContext();
  const { serviceUsersToDisplay } = useGetServiceUserList(
    selectedFilter,
    searchValue
  );
  const results = getFormattedResultsForDashboardUsers(
    selectedFilter,
    serviceUsersToDisplay
  );

  const track = useAmplitudeTracking();

  const trackServiceUserList = (eventProperties: Record<string, string>) => {
    track("Service User List", {
      ...eventProperties,
      location: "dashboard",
      filter_type: toSnakeCase(selectedFilter),
    });
  };

  return (
    <div className={styles.dashboard_users_container}>
      {results.map((category, index) => (
        <SearchResultBucket
          title={category?.title}
          tip={category?.tip}
          searchResultsData={category?.data}
          key={`${category?.title}-${index}`}
          numOfSUs={category?.numOfSUs}
          onTrack={trackServiceUserList}
        />
      ))}
    </div>
  );
};

export default DashboardUsers;
